import {Repository, createRepository} from '@/repositories/Base/Repository'

class InteroperaRepository extends Repository {
    endpoint = 'integration/interopera-logs'

    post(params) {
        return this.$axios.post(`integration/interopera`, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }
}

export default new InteroperaRepository()

export const create = createRepository(InteroperaRepository)
